import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faTrashCan} from '@fortawesome/pro-solid-svg-icons';
import {ProposalActionsComponent} from '../proposal-actions/proposal-actions.component';
import {ProposalStatusBadgeComponent} from '../proposal-status-badge/proposal-status-badge.component';

/**
 * Rein präsentationale Karte für einen Eintrag (Prüfregel, IDS-Spezifikation …), den ein
 * chatBIC-Vorschlag löschen will: rot umrahmt, Name durchgestrichen, Badge „Wird gelöscht“ plus
 * ✓ „Löschen übernehmen“ und ✗ „Behalten“. Die Entscheidung selbst trifft der jeweilige Editor.
 */
@Component({
  selector: 'app-removed-rule-card',
  standalone: true,
  imports: [FaIconComponent, ProposalActionsComponent, ProposalStatusBadgeComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './removed-rule-card.component.html',
})
export class RemovedRuleCardComponent {
  @Input({required: true}) itemName!: string;
  /** Bezeichnung des Eintragstyps im Hinweistext. */
  @Input() itemLabel = 'Prüfregel';
  @Output() removeClicked = new EventEmitter<void>();
  @Output() restoreClicked = new EventEmitter<void>();

  protected readonly faTrashCan = faTrashCan;
}
